<template>
    <div class="uhe-dropzone">
        <div :class="{ 'd-none': cropping }">
            <file-pond ref="pond" @init="initPond" @addfile="onAddFile"></file-pond>
        </div>
        <div :class="{ 'd-none': !cropping }">
            <div class="mb-2">Bitte wählen Sie den zu verwendenden Bereich aus</div>
            <vue-cropper
                ref="cropper"
                :src="imgSrc"
                :view-mode="1"
                :initialAspectRatio="ratio"
                :ready="onCropReady"
                :cropmove="onCropMove"
            ></vue-cropper>
            <div class="d-flex justify-content-end">
                <button class="btn uhe-btn mt-2" @click="confirmCrop()">Auswählen</button>
            </div>
        </div>
        <alert ref="alert" :content="alert.content" :timeout="5000"></alert>
        <alert
            ref="responseAlertDropzone"
            :content="responseAlertDropzone.content"
            :color="responseAlertDropzone.color"
            :timeout="5000"
        ></alert>
    </div>
</template>

<script>
import vueFilePond, { setOptions } from "vue-filepond";

import "filepond/dist/filepond.min.css";

import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";
import FilePondPluginImagePreview from "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js";
import FilePondPluginFileMetadata from "filepond-plugin-file-metadata/dist/filepond-plugin-file-metadata.esm";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";

const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview,
    FilePondPluginFileMetadata,
    FilePondPluginImageExifOrientation
);

import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
    components: {
        VueCropper,
        FilePond
    },
    props: {
        collection: {
            type: Number,
            required: false
        },
        multiple: {
            type: Boolean,
            required: false,
            default: true
        },
        cropper: {
            type: Boolean,
            required: false,
            default: false
        },
        minAspectRatio: {
            type: Number,
            default: 2
        },
        maxAspectRatio: {
            type: Number,
            default: 3
        }
    },
    data() {
        return {
            origImage: undefined,
            imgSrc: undefined,
            cropImage: undefined,
            cropping: false,
            ratio: 2,
            alert: {
                show: false,
                content: ""
            },
            responseAlertDropzone: {
                show: false,
                content: "",
                color: "success"
            }
        };
    },
    mounted() {},
    methods: {
        initPond() {
            setOptions({
                instantUpload: this.cropper ? false : true,
                server: {
                    url: "/images",
                    process: {
                        headers: {
                            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                                "content"
                            )
                        }
                    },
                    process: (
                        fieldName,
                        file,
                        metadata,
                        load,
                        error,
                        progress,
                        abort
                    ) => {
                        // set data
                        const formData = new FormData();
                        formData.append("file", file, file.name);
                        if (this.collection != undefined)
                            formData.append(
                                "selectedCollection",
                                this.collection
                            );

                        // related to aborting the request
                        const CancelToken = axios.CancelToken;
                        const source = CancelToken.source();

                        // the request itself
                        axios({
                            method: "post",
                            url: "/images",
                            data: formData,
                            cancelToken: source.token,
                            onUploadProgress: e => {
                                // updating progress indicator
                                progress(e.lengthComputable, e.loaded, e.total);
                            }
                        })
                            .then(response => {
                                // passing the file id to FilePond
                                load(response.data.id);
                                this.$emit("selected", response.data.id);
                            })
                            .catch(thrown => {
                                if (axios.isCancel(thrown)) {
                                    console.log(
                                        "Request canceled",
                                        thrown.message
                                    );
                                } else {
                                    if (
                                        thrown.response.data.message ==
                                        "The given data was invalid."
                                    ) {
                                        this.setResponseAlertDropzone(
                                            "error",
                                            "upload"
                                        );
                                        error();
                                        load();
                                    }
                                }
                            });

                        // Setup abort interface
                        return {
                            abort: () => {
                                source.cancel(
                                    "Operation canceled by the user."
                                );
                            }
                        };
                    }
                },
                allowImageExifOrientation: true,
                allowMultiple: this.multiple,
                labelIdle: "Bilder hierhin ziehen oder klicken",
                labelFileLoading: "Lade",
                labelFileProcessing: "Lädt hoch",
                labelFileProcessingComplete: "Hochgeladen",
                labelFileLoadError: "Lade-Fehler",
                labelFileProcessingError: "Upload-Fehler",
                dropValidation: true,
                maxParallelUploads: 15,
                allowRevert: false,
                acceptedFileTypes:
                    "image/jpeg, image/png, image/gif, image/jpg",
                styleItemPanelAspectRatio: "1"
            });
        },
        upload(file) {
            let image = this.dataURItoBlob(file);

            const formData = new FormData();
            formData.append("file", image, image.name);

            // related to aborting the request
            const CancelToken = axios.CancelToken;
            const source = CancelToken.source();

            // the request itself
            window
                .axios({
                    method: "post",
                    url: "/images",
                    data: formData,
                    cancelToken: source.token
                })
                .then(response => {
                    // passing the file id to FilePond
                    //this.initPond();
                    this.$emit("selected", response.data.id);
                })
                .catch(err => {
                    if (
                        err.response.data.exception ==
                        "Illuminate\\Http\\Exceptions\\PostTooLargeException"
                    ) {
                        this.setResponseAlertDropzone("error", "upload");
                    } else if (
                        err.response.data.message ==
                        "The given data was invalid."
                    ) {
                        this.setResponseAlertDropzone("error", "upload");
                        error();
                        load();
                    }
                });
        },
        confirmCrop() {
            this.cropImage = this.$refs.cropper
                .getCroppedCanvas()
                .toDataURL("image/jpeg");
            this.upload(this.cropImage);
            this.cropping = false;
        },
        onAddFile() {
            if (!this.cropper) return;

            const file = this.$refs.pond.getFile().source;
            this.cropping = true;

            if (!file.type.includes("image/")) {
                console.log("Please select an image file");
                return;
            }
            if (typeof FileReader === "function") {
                const reader = new FileReader();
                reader.onload = event => {
                    this.$emit("crop");
                    this.imgSrc = event.target.result;
                    // rebuild cropperjs with the updated source
                    this.$refs.cropper.replace(event.target.result);
                };
                reader.readAsDataURL(file);
            } else {
                console.log("Sorry, FileReader API not supported");
            }
        },
        dataURItoBlob(dataURI) {
            // convert base64/URLEncoded data component to raw binary data held in a string
            var byteString;
            if (dataURI.split(",")[0].indexOf("base64") >= 0)
                byteString = atob(dataURI.split(",")[1]);
            else byteString = unescape(dataURI.split(",")[1]);

            // separate out the mime component
            var mimeString = dataURI
                .split(",")[0]
                .split(":")[1]
                .split(";")[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], { type: mimeString });
        },
        onCropReady() {
            let cropper = this.$refs.cropper;
            let containerData = cropper.getContainerData();
            let canvasData = cropper.getCanvasData();
            let cropBoxData = cropper.getCropBoxData();
            let aspectRatio = cropBoxData.width / cropBoxData.height;
            let newCropBoxWidth;
            if (aspectRatio < this.minAspectRatio) {
                if (
                    cropBoxData.height * this.minAspectRatio <
                    canvasData.width
                ) {
                    cropper.setCropBoxData({
                        width: cropBoxData.height * this.minAspectRatio
                    });
                } else {
                    cropper.setCropBoxData({
                        height: cropBoxData.width / this.minAspectRatio
                    });
                }
            } else if (aspectRatio > this.maxAspectRatio) {
                if (
                    cropBoxData.height * this.maxAspectRatio <
                    canvasData.width
                ) {
                    cropper.setCropBoxData({
                        width: cropBoxData.height * this.maxAspectRatio
                    });
                } else {
                    cropper.setCropBoxData({
                        height: cropBoxData.width / this.maxAspectRatio
                    });
                }
            }
        },
        onCropMove(e) {
            let cropper = this.$refs.cropper;
            let cropBoxData = cropper.getCropBoxData();
            let canvasData = cropper.getCanvasData();
            let aspectRatio = cropBoxData.width / cropBoxData.height;
            if (aspectRatio < this.minAspectRatio) {
                if (
                    cropBoxData.height * this.minAspectRatio <
                        canvasData.width &&
                    (e.detail.action == "s" || e.detail.action == "n")
                ) {
                    cropper.setCropBoxData({
                        width: cropBoxData.height * this.minAspectRatio
                    });
                } else {
                    cropper.setCropBoxData({
                        height: cropBoxData.width / this.minAspectRatio
                    });
                }
            } else if (aspectRatio > this.maxAspectRatio) {
                if (
                    cropBoxData.height * this.maxAspectRatio <
                        canvasData.width &&
                    (e.detail.action == "s" || e.detail.action == "n")
                ) {
                    cropper.setCropBoxData({
                        width: cropBoxData.height * this.maxAspectRatio
                    });
                } else {
                    cropper.setCropBoxData({
                        height: cropBoxData.width / this.maxAspectRatio
                    });
                }
            }
        },
        setResponseAlertDropzone(code, action) {
            switch (code) {
                case "error":
                    this.responseAlertDropzone.color = "danger";
                    if (action == "upload")
                        this.responseAlertDropzone.content =
                            "Fehler beim Upload des Bildes. Bitte beachten Sie die max Bildgröße von 20MB";
                    break;
            }
            this.$refs.responseAlertDropzone.open();
        }
    }
};
</script>

<style lang="scss">
@import "../../../sass/image-dropzone.scss";
</style>
